import {
  newTracker,
  trackPageView as snowplowTrackPageView,
  trackStructEvent,
  type BrowserTracker,
} from '@snowplow/browser-tracker';

const APP_ID = `no.nrk.delta.${import.meta.env.VITE_CLIENT_ID}`;
const TRACKER_ID = 'delta-tracker-generisk';
const HOST = import.meta.env.VITE_SNOWPLOW_URL;

let snowplowTracker: BrowserTracker | undefined = undefined;

export function initializeSnowPlowTracker() {
  snowplowTracker = newTracker(TRACKER_ID, HOST, {
    appId: APP_ID,
    postPath: '/nrk/wd6',
    eventMethod: 'beacon',
    encodeBase64: import.meta.env.DEV ? false : true, //for debugging
    stateStorageStrategy: 'cookieAndLocalStorage',
  });
}

export const setUser = (userId: string) => {
  snowplowTracker?.setUserId(userId);
};

export const trackPageView = () => {
  snowplowTrackPageView(
    {
      context: getContext(),
    },
    [TRACKER_ID]
  );
};

type ClickAction =
  | 'could-not-vote-open'
  | 'feedback-submit'
  | 'further-feedback-submit'
  | 'feedback-close'
  | 'further-feedback-close'
  | 'feedback-open'
  | 'further-feedback-open'
  | 'add-vote'
  | 'remove-vote'
  | 'submit-votes'
  | 'submit-votes-disabled'
  | 'tooltip-close'
  | 'promo'
  | 'pre-open-select'
  | 'disabled-select'
  | 'add-favourite'
  | 'remove-favourite';

type ErrorAction =
  | 'fetching-clientstate'
  | 'submit'
  | 'weird-submit'
  | 'feedback-submit'
  | 'further-feedback-submit'
  | 'initializing-confetti'
  | 'accesstoken-undefined';

type StateAction =
  | 'before-poll'
  | 'open-poll'
  | 'closed-poll'
  | 'after-poll'
  | 'empty-poll'
  | 'login'
  | 'poster';

type Action =
  | `click:${ClickAction}`
  | `error:${ErrorAction}`
  | `state:${StateAction}`
  | `success:submit`;

type Event = Omit<Parameters<typeof trackStructEvent>[0], 'category'> & {
  action: Action;
};

export const trackEvent = (event: Event, contentId?: string) => {
  trackStructEvent(
    {
      ...event,
      category: 'PIN',
      context: getContext(contentId),
    },
    [TRACKER_ID]
  );
};

const getContext = (contentId?: string) => {
  const context: Array<{ schema: string; data: Record<string, string> }> = [
    {
      schema: 'iglu:no.nrk/service/jsonschema/2-0-0',
      data: {
        id: 'nrkno',
        environment: import.meta.env.VITE_APP_ENV,
      },
    },
  ];
  if (snowplowTracker?.getUserId()) {
    context.push({
      schema: 'iglu:no.nrk/nrk-user/jsonschema/1-0-0',
      data: {
        id: snowplowTracker?.getUserId() as unknown as string,
      },
    });
  }
  if (contentId != null) {
    context.push({
      schema: 'iglu:no.nrk/content/jsonschema/1-0-1',
      data: {
        id: contentId,
        kind: 'avstemning',
        source: 'midas',
      },
    });
  }
  return context;
};
